import { isSuperAdminUserRole } from './platformAdminAccess';

export function getMemberOrganisationIds(
  organisations?: Record<string, unknown> | null
): string[] {
  return organisations ? Object.keys(organisations) : [];
}

/**
 * Super admins may inspect any organisation. Everyone else with memberships
 * should land on an organisation they actually belong to.
 */
export function allowsAnyOrganisationSelection(user?: {
  userRole?: string | null;
  platformAdminRole?: string | null;
} | null): boolean {
  return (
    isSuperAdminUserRole(user?.userRole) || isSuperAdminUserRole(user?.platformAdminRole)
  );
}

export function resolvePreferredOrganisationId(options: {
  memberOrgIds: string[];
  availableOrgIds: string[];
  currentOrgId?: string | null;
  allowAnyOrganisation: boolean;
  fallbackOrgId?: string | null;
}): string | null {
  const available = options.availableOrgIds;
  const members = options.memberOrgIds.filter((id) => available.includes(id));
  const current =
    options.currentOrgId && available.includes(options.currentOrgId)
      ? options.currentOrgId
      : null;
  const fallback =
    options.fallbackOrgId && available.includes(options.fallbackOrgId)
      ? options.fallbackOrgId
      : null;

  if (options.allowAnyOrganisation) {
    return current || members[0] || fallback || available[0] || null;
  }

  if (current && members.includes(current)) return current;
  return members[0] || current || fallback || available[0] || null;
}

export function sortOrganisationsMemberFirst<T extends { id: string }>(
  orgs: T[],
  memberOrgIds: string[]
): T[] {
  const memberSet = new Set(memberOrgIds);
  return [...orgs].sort((a, b) => {
    const aMember = memberSet.has(a.id) ? 0 : 1;
    const bMember = memberSet.has(b.id) ? 0 : 1;
    return aMember - bMember;
  });
}
